import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const baseUrlEvent = process.env.REACT_APP_EVENT_MANAGEMENT;

export const getFacilityAuditLog = createAsyncThunk('getFacilityAuditLog', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlEvent}/events`, { params: queryParams });
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getAuditTrailByTransactionID = createAsyncThunk(
    'getAuditTrailByTransactionID',
    async (queryParams, thunkAPI) => {
        try {
            const response = await axios.get(`${baseUrlEvent}/events/investor`, { params: queryParams });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            const errorMessage = error.response?.data?.serviceMessage || error.message;
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const getNotifications = createAsyncThunk('getNotifications', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlEvent}/notifications`, { params: queryParams });
        const { payload, has_next, next_cursor } = response.data;

        return { count: payload.count, notifications: payload.notifications, nextPage: { has_next, next_cursor } };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const deleteArchiveNotification = createAsyncThunk(
    'deleteArchiveNotification',
    async (req, { dispatch, thunkAPI }) => {
        const { query, geQuery } = req;
        const queryNew = {
            organizationULID: geQuery.organizationULID,
            limit: 3,
            cursor: 0,
        };
        // 🔹 Show pending toast before the request
        toast.info('Deleting notification...', {
            icon: <i className='bi bi-hourglass-split' style={{ color: '#007bff' }}></i>,
        });
        try {
            const response = await axios.patch(`${baseUrlEvent}/notifications/archive`, query);

            if (response) {
                dispatch(getNewNotifications(queryNew));
                dispatch(getNotifications(geQuery));
                toast.success(response.data.serviceMessage, {
                    icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
                });
            }
            return response;
        } catch (error) {
            const errorMessage = error.response?.data?.serviceMessage || error.message;
            toast.error(errorMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const getNewNotificationsCount = createAsyncThunk('getNewNotificationsCount', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlEvent}/getNewNotificationsCount`, { params: queryParams });
        const { payload } = response.data;

        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getNewNotifications = createAsyncThunk('getNewNotifications', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlEvent}/notifications`, { params: queryParams });
        const { payload } = response.data;

        return { count: payload.count, notifications: payload.notifications };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const sendEmail = createAsyncThunk('sendEmail', async (req, thunkAPI) => {
    try {
        const response = await axios.post(`${baseUrlEvent}/email`, req);
        const payload = response.data;
        if (response) {
            toast.success(response.data.payload || response.data.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
        }
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getTransactionEventLogs = createAsyncThunk('getTransactionEventLogs', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlEvent}/events`, { params: queryParams });
        const { payload } = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
